package uz.ferro.erp.feature.text.model

enum class ListStyle {
    NONE,
    DISC,
    CIRCLE,
    SQUARE,
    DECIMAL
}